import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Pagination } from '@dev/ee-components';

import { ApplicationState } from '@/store';
import useMobile from '@/services/hooks/useMobile';
import { GetCampaigns, UnpickAllCampaigns } from '@/store/campaigns/actions';
import { useRequestParams } from '../../hooks/useRequestParams';

const PaginationComponent: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const requestParams = useRequestParams();
    const {
        campaigns: { statusCount },
    } = useSelector((state: ApplicationState) => state);

    const changePage = (activePage: number, perPage: number): void => {
        const offset = activePage * perPage - perPage;

        dispatch(UnpickAllCampaigns());
        dispatch(GetCampaigns({ ...requestParams, limit: perPage, offset }));
    };

    const activePage = (requestParams.offset + requestParams.limit) / requestParams.limit;

    return (
        <Pagination
            dataLength={statusCount?.total}
            perPage={requestParams.limit}
            handlePaginationChange={(activePage, perPage): void => changePage(activePage, perPage)}
            activePage={activePage}
            siblingCount={1}
            boundaryCount={1}
            disableBorderTop={isMobile}
        />
    );
};

export default PaginationComponent;
